import req from '../http.js';

// 添加或修改逻辑库
export const addOrEditLogical = (params) => {
  return req('post', '/console/pipeline-logical-db/addOrEdit', params);
};

// 删除逻辑库
export const deleteLogicalDB = (params) => {
  return req('get', '/console/pipeline-logical-db/deleteLogicalDB', {
    ...params
  });
};

// 获取逻辑库详情
export const getLogicalDetail = (params) => {
  return req('get', '/console/pipeline-logical-db/getDetail', {
    ...params
  });
};

// 获取逻辑库列表
export const getLogicalList = (params) => {
  return req('get', '/console/pipeline-logical-db/getList', {...params});
};

// 新增或修改逻辑Table表
export const addOrEditLogicalTable = (params) => {
  return req('post', '/console/pipeline-logical-table/addOrEdit', params)
};

// 删除逻辑table表
export const deleteLogicalTable = (params) => {
  return req('get', '/console/pipeline-logical-table/deleteLogicalTable', {
    ...params
  });
};

// 获取逻辑Table列表
export const getLogicalTableList = (params) => {
  return req('get', '/console/pipeline-logical-table/getList', {
    ...params
  });
};

// 根据逻辑库SchemaID获取table列表
export const getListBySchemaIDOfLogical = (params) => {
  return req('get', '/console/pipeline-logical-table/getListBySchemaID', {
    ...params
  });
};

// 新增或修改逻辑库Schema
export const addOrEditSchemaIDByLogical = (params) => {
  return req('post', '/console/pipeline-logical-schema/addOrEdit', params);
};
// 删除逻辑库Schema
export const deleteLogicalSchema = (params) => {
  return req('get', '/console/pipeline-logical-schema/deleteLogicalSchema', {
    ...params
  });
};
// 获取逻辑库Schema列表
export const getLogicalSchemaList = (params) => {
  return req('get', '/console/pipeline-logical-schema/getList', {
    ...params
  });
};
// 根据逻辑库ID获取schema列表
export const getLogicalListByDataBaseId = (params) => {
  return req('get', '/console/pipeline-logical-schema/getListByDataBaseID', {
    ...params
  });
};
